export default class LostReceiptsWorkflow {
  constructor(companyData, lostReceiptTransactions) {
    this.companyData = companyData;
    this.transactionsData = lostReceiptTransactions;
  }

  allTransactionsAssigned() {
    return this.transactionsData.filter((transaction) => transaction.accounting_type === "incomplete").length === 0;
  }

  transactionAssignmentUpdated(transactionId, newAllocation) {
    this._retrieveTransaction(transactionId).accounting_type = newAllocation;
  }

  transactionShareholderDefined(transactionId, shareholderId) {
    this._retrieveTransaction(transactionId).shareholder_id = parseInt(shareholderId);
  }

  transactionChargeDefined(transactionId, categoryId) {
    this._retrieveTransaction(transactionId).category_id = parseInt(categoryId);
  }

  shareholderAccountTransactions() {
    return this.transactionsData.filter((transaction) => transaction.accounting_type === "shareholders_account");
  }

  chargeTransactions() {
    return this.transactionsData.filter((transaction) => transaction.accounting_type === "charge");
  }

  shouldDefineShareholders() {
    if (this.shareholderAccountTransactions().length === 0) {
      return false;
    }

    return this.hasMultipleShareholders();
  }

  shouldDefineCharges() {
    return this.chargeTransactions().length !== 0;
  }

  hasMultipleShareholders() {
    return this.companyData.multiple_shareholders;
  }

  shareholderAccountTransactionsParams() {
    let params;

    if (this.hasMultipleShareholders()) {
      params = this._groupedTransactions(this.shareholderAccountTransactions(), "shareholder_id");
    } else {
      const shareholderId = this.companyData.default_shareholder_id;
      const transactionsIds = this.shareholderAccountTransactions().map((transaction) => transaction.id);
      params = { [shareholderId]: transactionsIds };
    }

    return { shareholders: params };
  }

  chargeTransactionsParams() {
    return { categories: this._groupedTransactions(this.chargeTransactions(), "category_id") };
  }

  _groupedTransactions(transactions, group_by_key) {
    return transactions.reduce((acc, transaction) => {
      const groupKey = transaction[group_by_key];
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(transaction.id);
      return acc;
    }, {});
  }

  _retrieveTransaction(transactionId) {
    return this.transactionsData.find((transaction) => transaction.id === parseInt(transactionId));
  }
}
